import { Checkbox } from "../Checkbox"
import { IResponsiveDisplay } from "../../../../base/styles"
import { SelectDisplay } from "./SelectDisplay"
import clsx from "clsx"
import { useState } from "react"

export const EditDisplay = ({ value, title, className, onChange }: {
    title: string,
    value: IResponsiveDisplay,
    className?: string,
    onChange: (value?: IResponsiveDisplay) => void
}) => {
    const [responsive, setResponsive] = useState<boolean>();

    return <div className={clsx(className)}>
        <div className="d-flex align-items-end">
            <SelectDisplay
                title={title}
                className="flex-grow-1 pe-2"
                onChange={(newValue) => { onChange({ ...value, allSizes: newValue }) }}
                value={value?.allSizes} />
            <Checkbox
                title="Responsive"
                className="fs-8 fw-semibold"
                value={responsive === true}
                onChange={setResponsive} />
        </div>

        {responsive &&
            <div className="d-flex flex-row flex-wrap mx-5 my-3">
                <SelectDisplay
                    title="Small"
                    className="w-50 pe-2"
                    onChange={(newValue) => { onChange({ ...value, small: newValue }) }}
                    value={value?.small} />
                <SelectDisplay
                    title="Medium"
                    className="w-50 pe-2"
                    onChange={(newValue) => { onChange({ ...value, medium: newValue }) }}
                    value={value?.medium} />
                <SelectDisplay
                    title="Large"
                    className="w-50 pe-2"
                    onChange={(newValue) => { onChange({ ...value, large: newValue }) }}
                    value={value?.large} />
                <SelectDisplay
                    title="Ex. Large"
                    className="w-50 pe-2"
                    onChange={(newValue) => { onChange({ ...value, xLarge: newValue }) }}
                    value={value?.xLarge} />
            </div>
        }
    </div>
}